<template>
  <div class="footer-color">
    <span class="text-muted footer-text">© 2021 Yuki Samuraki</span>
  </div>
</template>

<script>
export default {
  name: 'FooterBar'
}
</script>

<style scoped>
.footer-color {
  background: rgba(0, 0, 0, .7);
}

.footer-text{
  font-size: .8em;
}
</style>